import { render, staticRenderFns } from "./VlLogTableData.vue?vue&type=template&id=6504a203&scoped=true&"
import script from "./VlLogTableData.vue?vue&type=script&lang=js&"
export * from "./VlLogTableData.vue?vue&type=script&lang=js&"
import style0 from "./VlLogTableData.vue?vue&type=style&index=0&id=6504a203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504a203",
  null
  
)

export default component.exports